import { GroupListResult } from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function listGroups(): Promise<GroupListResult> {
  return httpClient.get<GroupListResult>('/protected/groups');
}
